const dashboardDefaults = {
	dashboard: 'default',
};

function DashboardSettings($rootScope, $http) {

	const settings = {};

	const ctrl = {
		_reloadInfo() {
			const url = '/application-settings/rm_dashboard';
			settings._promise = $http.get(url).then(response => {
				ctrl._mergeNewSettings(response.data);
			});
		},
		_mergeNewSettings(newSettings) {
			Object.assign(
				settings,
				ctrl,
				dashboardDefaults,
				newSettings,
			);
		},
	};

	$rootScope.$on('applicationsSaved', () => {
		ctrl._reloadInfo();
	});

	ctrl._reloadInfo();

	ctrl._mergeNewSettings({});
	return settings;
}

module.exports = [
	'$rootScope',
	'$http',
	DashboardSettings,
];
